(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-waiting.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-waiting.js');

'use strict';

const {
  logger
} = svs.playerLoginReact;
const {
  ReactButton: Button
} = svs.ui;
const {
  useHistory
} = ReactRouterDOM;
const {
  Loader
} = svs.components.ReactLoader;
const {
  frejaeIdProgressStatus,
  appWaitStatus,
  route
} = svs.playerLoginReact.constants;
const useFrejaeIdPollStatus = svs.playerLoginReact.frejaeid.useFrejaeIdPollStatus;
const {
  frejaeIdBackendStatus
} = svs.playerLoginReact.store.playerloginreactactions;
const {
  useUrlHelper,
  LoginQrCode,
  AriaCountdownTimer,
  SelectEidMenu
} = svs.playerLoginReact.sharedComponents;

const FrejaeIdWaiting = _ref => {
  let {
    isLogin = true,
    frejaeIdPollWait = appWaitStatus.WAITING_QRCODE
  } = _ref;
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const frejaeIdAuthRef = ReactRedux.useSelector(state => state.playerloginreact.authRef);
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const {
    appUrl,
    qrCode,
    backendStatus,
    cancelBackendPoll,
    isLastQrRetry,
    TIME_TO_POLL_TIMEOUT
  } = useFrejaeIdPollStatus(isLogin, frejaeIdAuthRef);
  const [waitStatus, setWaitStatus] = React.useState(frejaeIdProgressStatus.BEFORE_POLL);
  const [shouldShowScanText, setShouldShowScanText] = React.useState(true);
  const {
    navigateToCancelUrl
  } = useUrlHelper();
  const TIME_REMAINING_WHEN_TO_DISPLAY_ARIA = TIME_TO_POLL_TIMEOUT - 40; 
  logger.debug('**** app url', appUrl);

  React.useEffect(() => {
    dispatch(frejaeIdBackendStatus(backendStatus));
    setWaitStatus(backendStatus);
  }, [backendStatus]);
  React.useEffect(() => {
    logger.debug('appurl:', appUrl);
    if (appUrl && appUrl.length > 5 && frejaeIdPollWait === appWaitStatus.WAITING_APP) {
      logger.debug('**** open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  }, [appUrl]);
  React.useEffect(() => {
    if (isLastQrRetry) {
      const btn = document.getElementById('retryButton');
      if (btn) {
        btn.focus();
      }
    }
  }, [isLastQrRetry]);
  const handleTimerDone = React.useCallback(() => {
    setShouldShowScanText(false);
  }, []);
  const onCancelClick = async () => {
    await cancelBackendPoll();
    if (isStandardMobile) {
      const loginPath = baseUrl;
      logger.debug("**** Doing hard load of ".concat(isLogin ? 'login' : 'registrate'));
      if (isLogin) {
        svs.utils.url.navigate(loginPath + route.LOGIN_FREJAEID_START_ROUTE);
      } else {
        svs.utils.url.navigate(loginPath + route.REGISTRATE_FREJAEID_ROUTE);
      }
    } else if (frejaeIdPollWait === appWaitStatus.WAITING_QRCODE) {
      navigateToCancelUrl();
    } else if (isLogin) {
      history.push(route.LOGIN_FREJAEID_START_ROUTE);
    } else {
      history.push(route.REGISTRATE_FREJAEID_ROUTE);
    }
  };
  const onRetry = () => {
    cancelBackendPoll();
    history.push(isLogin ? route.LOGIN_FREJAEID_START_ROUTE : route.REGISTRATE_FREJAEID_START_ROUTE);
  };
  const handleLoginOnOtherDevice = () => {
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Mobile Fallback',
      opt_label: 'frejaeid'
    });
    history.push(isLogin ? route.LOGIN_FREJAEID_POLL_QR_ROUTE : route.REGISTRATE_FREJAEID_POLL_QR_ROUTE);
  };
  logger.debug('frejaeidwaitstatus', waitStatus);
  logger.debug('frejaeidpollwait', frejaeIdPollWait);
  return React.createElement("div", {
    className: "fc-navy"
  }, (waitStatus === frejaeIdProgressStatus.BEFORE_POLL || waitStatus === frejaeIdProgressStatus.WAITING_APP) && frejaeIdPollWait === appWaitStatus.WAITING_APP && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-4 margin-top-3 margin-bottom-1"
  }, React.createElement("p", null, "F\xF6rs\xF6ker starta Freja eID-appen")), isStandardMobile && React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement(Button, {
    block: true,
    onClick: handleLoginOnOtherDevice,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 en annan enhet"))), (waitStatus === frejaeIdProgressStatus.BEFORE_POLL || waitStatus === frejaeIdProgressStatus.SHOWING_QRCODE || waitStatus === frejaeIdProgressStatus.ERROR_POLL || waitStatus === frejaeIdProgressStatus.CLIENT_TIMEOUT) && frejaeIdPollWait === appWaitStatus.WAITING_QRCODE && React.createElement(React.Fragment, null, !isStandardMobile && React.createElement(SelectEidMenu, {
    isLogin: isLogin
  }), React.createElement(LoginQrCode, {
    errorMessage: "Inloggningen tog f\xF6r l\xE5ng tid.",
    isError: waitStatus === frejaeIdProgressStatus.CLIENT_TIMEOUT,
    qrCode: qrCode
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement(AriaCountdownTimer, {
    onDone: handleTimerDone,
    showTime: TIME_REMAINING_WHEN_TO_DISPLAY_ARIA,
    startTime: TIME_TO_POLL_TIMEOUT
  })), !isStandardMobile && isLastQrRetry && React.createElement(Button, {
    block: true,
    className: "margin-bottom-2",
    id: "retryButton",
    onClick: onRetry,
    tabIndex: 0,
    transparent: true
  }, "F\xF6rl\xE4ng tid"), shouldShowScanText && React.createElement("p", {
    className: "padding-am-bottom-1"
  }, "Skanna QR-koden med Freja eID-appen")))), (waitStatus === frejaeIdProgressStatus.SHOWING_SPINNER || waitStatus === frejaeIdProgressStatus.NEW_CUSTOMER || waitStatus === frejaeIdProgressStatus.RETAIL_CUSTOMER || waitStatus === frejaeIdProgressStatus.REACTIVATED_CUSTOMER || waitStatus === frejaeIdProgressStatus.ONLINE_CUSTOMER) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-8"
  }, waitStatus === frejaeIdProgressStatus.SHOWING_SPINNER ? 'Väntar på identifiering i app' : 'Loggar in...'), React.createElement("div", {
    className: "login-react-margin-top-7 login-react-loader-view-container"
  }, React.createElement(Loader, {
    size: 300
  }))), React.createElement("div", null, React.createElement(Button, {
    block: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLoginReact.frejaeid.components.FrejaeIdWaiting = FrejaeIdWaiting;

 })(window);